module.exports = __webpack_public_path__ + "static/Slide01@3x.3ab058be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Slide01@3x.png
// module id = 704
// module chunks = 216210090109534